import Link from 'next/link';
import { useContext, useMemo } from 'react';
import { RankingProducts } from 'src/components/pages/search/RankingProducts';
import { MainContainer } from 'src/components/shared/layouts/MainContainer';
import { QuestionnaireSticker } from 'src/components/shared/templates/questionnaire/QuestionnaireSticker';
import { KaimonoWebRoutes } from 'src/config/routes';
import { BrandsContext } from 'src/stores/Brands';
import { I18nContext } from 'src/stores/I18n';
import { mixpanel } from 'src/utils/mixpanel';
import styles from './index.module.scss';

type Props = {
  keyword: string;
};

export const NoSearchResults: React.FC<Props> = ({ keyword }) => {
  const localeResources = useContext(I18nContext);
  const brands = useContext(BrandsContext);
  const sk2 = useMemo(() => brands.find((_brand) => _brand.slug === 'sk2'), [brands]);
  const shuuemura = useMemo(() => brands.find((_brand) => _brand.slug === 'shuuemura'), [brands]);
  const dhc = useMemo(() => brands.find((_brand) => _brand.slug === 'dhc'), [brands]);
  const orbis = useMemo(() => brands.find((_brand) => _brand.slug === 'orbis'), [brands]);

  const keywords = [
    {
      word: localeResources.index.omiyageRecommendation.title,
      url: KaimonoWebRoutes.featured.omiyage
    },
    {
      word: localeResources.recommended.mustBuyPopularJapaneseGoods,
      url: KaimonoWebRoutes.recommended
    },
    { word: shuuemura?.name, url: `/brands/${shuuemura?.brandId}` },
    { word: sk2?.name, url: `/brands/${sk2?.brandId}` },
    { word: orbis?.name, url: '/search?i=orbis' },
    { word: dhc?.name, url: `/brands/${dhc?.brandId}` }
  ];

  return (
    <>
      <MainContainer>
        <div className={styles.container}>
          <div className={styles.noResult}>{localeResources.search.noResultFor(keyword)}</div>
          <div className={styles.questionnaireContainer}>
            <QuestionnaireSticker mixpanelEventType="sticker" />
          </div>
          <div className={styles.keywordContainer}>
            <div className={styles.popular}>{localeResources.search.popularKeywords}</div>
            {keywords.map((w, i) => (
              <Link key={`${w.url}-${i}`} href={w.url}>
                <a className={styles.word} onClick={() => mixpanel.onPopularKeywordsClicked(w.word ?? '')}>
                  {w.word}
                </a>
              </Link>
            ))}
          </div>
        </div>
      </MainContainer>
      <RankingProducts />
    </>
  );
};
